export const BioObj = {
    id : 'bio',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    imgStart: false,
    img: require('../../images/profilepic.jpg').default,
    darkText: false
};

